import React, { Component } from 'react';
import { Container } from 'flux/utils';

import { Card, CardHeader } from 'material-ui/Card';
import ReportCourseProgress from './ReportCourseProgress.react';
import ReportModuleProgress from './ReportModuleProgress';

import ReportActions from '../../actions/ReportActionCreator';
import ReportShareStore from '../../stores/ReportShareStore';

class ReportShare extends Component {

    componentDidMount() {
        ReportActions.getSharedResults(this.props.routeParams.key);
    }

    render() {
        if (!this.state.results || !this.state.results.length) { return null; }

        const display = {
            fixedHeader: true,
            fixedFooter: true,
            stripedRows: false,
            showRowHover: false,
            showCheckboxes: false,
            selectable: false,
            multiSelectable: false,
            enableSelectAll: false,
            deselectOnClickaway: false,
        };

        let results;
        switch (this.state.reportType) {
            case 'course_progress':
                results = <ReportCourseProgress display={display} data={this.state.results} withLinks={false}/>;
                break;
            case 'module_progress':
                results = <ReportModuleProgress display={display} data={this.state.results} withLinks={false}/>;
                break;
            default:
                results = null;
        }

        return (
            <Card className="cent-card">
                <CardHeader
                    className="cent-card-header"
                    title={this.state.reportName}
                />
                {results}
            </Card>
        );
    }
}

ReportShare.getStores = () => [ReportShareStore];
ReportShare.calculateState = (prevState, { routeParams }) => ReportShareStore.getResultsByKey(routeParams.key) || {};

export default Container.create(ReportShare, {withProps: true});
